var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-an-order"},[(_vm.showSearch)?_c('div',[_c('shopping-search',{attrs:{"text":_vm.searchText}}),_c('DashboardFooter',{})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }